import axiosInstanceProxy from "./config";

export const getSubscriptionsRequest = () => axiosInstanceProxy.get(`/admin/subscriptions`);

export const getOptionsRequest = () => axiosInstanceProxy.get(`/admin/options`);
